import {
  formatNumberRoundDownToNearest,
  formatNumberRoundUpToNearest
} from 'util/formatters/numberFormatter';
import { findIndex, inRange, times, uniq } from 'lodash';
import { MAXIMUM_AXIS_RANGE_INCREASE } from '../../../constants/data-viz';

export const getAxisBounds = ({ range, defaultRange = {max: 0, min: 0} }) => {
  // round values like we do in the ui for comparison purposes
  const uniqueSortedValues = uniq(range.map((value) => Math.round(value))).sort((a, b) => a-b);
  const first = uniqueSortedValues[0];
  const last = uniqueSortedValues.slice(-1)[0];
  const { max, min } = defaultRange;

  // if all populations are the same or range is empty without 0, substitute default min/max population to generate
  // range otherwise, return first/last values of original range
  return uniqueSortedValues.length <= 1 ? [min, max] : [first, last];
};

export const getAxisBins = ({ axisBounds, binRoundingValue, numBins }) => {
  let [ min, max ] = axisBounds;

  min = formatNumberRoundDownToNearest(min, binRoundingValue);
  max = formatNumberRoundUpToNearest(max, binRoundingValue);

  const valueRange = max - min;
  const avgBinSize = valueRange / numBins;
  // round the bin size to the nearest binRoundingValue if the range will not
  // increase by more than the MAXIMUM_AXIS_RANGE_INCREASE
  const roundedBinSize = formatNumberRoundUpToNearest(avgBinSize, binRoundingValue);
  const binSize = avgBinSize * MAXIMUM_AXIS_RANGE_INCREASE > roundedBinSize
    ? roundedBinSize
    : Math.round(avgBinSize);
  return times(numBins, (index) => {
    if((index + 1) === numBins) {
      return [(min + (binSize * index)), (min + (binSize * (index + 1)))];
    }
    return [(min + (binSize * index)), (min + (binSize * (index + 1)) - 1)];
  });
};

export const getBinIndexForValue = ({ bins, value }) => {
  return findIndex(bins, (bin) => inRange(value, bin[0], bin[1]));
};
